import Cookie from 'js-cookie'

const Remark = 'remark';

export function getRemark(){
    // return window.localStorage.getItem(Remark)
    return Cookie.get(Remark);
}

export function setRemark(info){
    return Cookie.set(Remark,info)
    // return window.localStorage.setItem(Remark,info)
}

export function removeRemark(){
    // return window.localStorage.removeItem(Remark)
    return Cookie.remove(Remark)
}


// WEBPACK FOOTER //
// ./src/utils/remark.js